import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/shared/services/auth.service';
import { TranslateService } from 'src/shared/services/translate.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.translate.load('extracurricular', 'dashboard');
    this.dashboardInit();
  }

  dashboardInit(): void {
    const current = this.authService.current();

    const isSuperAdmin = current.roles.includes('SUPERADMIN');
    const isParent = current.roles.includes('ORANGTUA');
    const isStudent = current.roles.includes('STUDENT');

    const isKepsek = current.roles.includes('KEPALASEKOLAH');
    const isYayasan = current.roles.includes('YAYASAN');

    if (isStudent) {
      this.router.navigate(['student'], { relativeTo: this.route });
      return;
    }
    if (isParent) {
      this.router.navigate(['student'], { relativeTo: this.route });
      return;
    }

    if (isKepsek || isYayasan || isSuperAdmin) {
      this.router.navigate(['admin'], { relativeTo: this.route });
      return;
    }
  }

}
